import cx from "classnames";
import styles from "./ArticleLeadFigure.module.scss";

type FigureProps = {
  captionText?: string | null;
  attributionText?: string | null;
  attributionUrl?: string | null;
  layout: "standard" | "feature" | "twocol";
};

const Attribution = ({
  url,
  children,
}: {
  url: string | null | undefined;
  children: React.ReactNode;
}) => {
  return url ? (
    <a href={url} className={styles.link}>
      {children}
    </a>
  ) : (
    <>{children}</>
  );
};

const ArticleLeadFigure = ({
  children,
  captionText,
  attributionText,
  attributionUrl,
  layout,
}: {
  children: React.ReactNode;
} & FigureProps) => {
  return (
    <figure className={cx(styles.root, styles[layout])}>
      <div
        className={cx(
          styles.media,
          layout === "feature" && styles.featureBackground
        )}
      >
        {children}
      </div>
      {(captionText || attributionText) && (
        <figcaption
          className={cx(
            styles.caption,
            layout === "standard" && styles.standardCaption,
            layout === "feature" && styles.featureCaption
          )}
        >
          {captionText && (
            <span dangerouslySetInnerHTML={{ __html: captionText }} />
          )}
          {attributionText && (
            <>
              {captionText && "\u00a0("}
              <Attribution url={attributionUrl}>{attributionText}</Attribution>
              {captionText && ")"}
            </>
          )}
        </figcaption>
      )}
    </figure>
  );
};

export default ArticleLeadFigure;
